import SeoHead from '../components/SeoHead'
import SubscriptionSuccessView from '../views/SubscriptionSuccess'
import { useLanguage } from '../i18n/LanguageContext'

const SubscriptionSuccessPage = () => {
  const { t } = useLanguage()

  return (
    <>
      <SeoHead
        title={t('seo.subscriptionSuccessTitle')}
        description={t('seo.subscriptionSuccessDescription')}
        path="/subscription-success"
        noIndex
      />
      <SubscriptionSuccessView />
    </>
  )
}

export default SubscriptionSuccessPage
